import "./GameBoardActivities/MapMaze.css";
import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { createAdditionalSpace } from "./objects/createAdditionalSpace";
import { clearMazeBoard } from "./objects/clear_maze_board";
import { Button } from '@mui/material';
import _ from "lodash";
import { findDataObject } from "../../objects/CommonUse/find_data_object";
import { setPathInMaze } from "./objects/set_path_in_maze";
import { setBlackOutSpaces } from "./objects/set_black_out_spaces";
import { createGoodPath } from "./objects/createGoodPath_function";
import { createWiderPath } from "./objects/createWiderPath";
import { removeClearPath } from "./objects/create_clear_path";
import {displayFriendComment} from "./objects/display_friend_comment";
import {determineFriendComment} from "./objects/determine_friend_comment"


function MazeGameModal(props) {
  const [gridWidth] = useState(props.width);
  const [gridHeight] = useState(props.height);
  const [pctBlocked] = useState(props.pctBlocked);
  const [isTouchDevice] = useState('ontouchstart' in window || navigator.maxTouchPoints > 0);
  const [mazeMemes] = useState(props.mazeParms);
  const [timeAllowed] = useState(props.timeAllowed * 1000);
  const [category]=useState(props.category);
  const [gameStarted, setGameStarted] = useState(false);
  const [disable, setDisable] = useState(false);
  const [gameOver, setGameOver] = useState(false);
  const [objectiveMet, setObjectiveMet] = useState(false);
  const [avatar, setAvatar] = useState("1");
  const avatarRef = React.useRef("1"); // always reflects latest avatar for interval closures
  const [objective, setObjective] = useState("1");
  const [splits, setSplits] = useState([]);
  const [playBoard, setPlayBoard] = useState([]);
  const [moves, setMoves] = useState(0);
  const [deliveries, setDeliveries] = useState(0);
  const [totalScore, setTotalScore] = useState(props.score.points);
  const [nbrGames, setNbrGames] = useState(props.nbrGames - props.score.gamesRemaining);
  const [maxNbrGames] = useState(props.nbrGames);
  const [score, setScore] = useState(findDataObject("activityScore").score);
  const [maxDeliveries, setMaxDeliveries] = useState(99);
  const [nbrPerfectGames, setNbrPerfectGames] = useState(0);
  const [maxScore, setmaxScore] = useState(props.score.maxScore);
  const [backToBeginning, setBackToBeginning] = useState("1");
  const [commentNbr, setCommentNbr] = useState("0");
  const [displayPicture, setDisplayPicture] = useState(false);
  const [comment, setComment] = useState("");
  const [resetDone, setResetDone] = useState(false);
  const [touchMode, setTouchMode] = useState(false);
  const [modeLocked, setModeLocked] = useState(false); // locked once Start is clicked
  const splitRefreshTimeoutRef = React.useRef(null);
  const [button1, setButton1] = useState("New Game");
  //

  // NEW: tracks whether the maze board has actually finished being drawn/
  // styled and is safe to move on. Movement, D-pad input, and the game/
  // countdown timers are all gated on this instead of on gameStarted alone,
  // since gameStarted flips true immediately in startGame() while the
  // board's visual setup (and formerly the timers) happened afterward.
  const [mazeReady, setMazeReady] = useState(false);
  // Flags that the NEXT run of the class-application effect is the initial
  // "board just got created" pass (as opposed to a normal in-game update
  // triggered by the player moving/collecting points), so we know when to
  // flip mazeReady and kick off the timers.
  const initialSetupPendingRef = React.useRef(false);
  // Carries the values startGame() computed (touch mode add-on time) forward
  // to the moment the maze actually becomes ready, since that's now when we
  // want to start the timers instead of immediately in startGame().
  const pendingTimerStartRef = React.useRef({ addSeconds: 0, effectiveTime: 0 });
  // NEW: guarantees the score/nbrGames/maxScore update for a round is computed
  // exactly once, the moment that round actually ends (timer expiry, objective
  // reached, or all points collected) — not deferred until the "New Game"
  // button is clicked. Also guards against double-counting if the player
  // Quits after the round has already ended but before clicking New Game.
  const scoreCommittedRef = React.useRef(false);

  const handleTouchToggle = (newTouchMode) => {
    if (modeLocked) return;
        setTouchMode(newTouchMode);
  };

  // ── Hold-to-repeat for D-pad ─────────────────────────────────────────────
  const holdInterval = React.useRef(null);
  const gameTimerRef = React.useRef(null);       // tracks internal game-over setTimeout

  const startHold = (keyCode) => {
    if (!mazeReady) return; // NEW: ignore D-pad presses until the maze has finished setting up
    // Fire once immediately, then repeat on interval.
    // boardRun is called directly with a synthetic event so moveAvatar
    // always reads the freshest avatar position via avatarRef.
    // const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    boardRun({ keyCode });
    holdInterval.current = setInterval(() => {
      boardRun({ keyCode });
    }, 150);
  };

  const stopHold = () => {
    if (holdInterval.current) {
      clearInterval(holdInterval.current);
      holdInterval.current = null;
    }
  };
  // ─────────────────────────────────────────────────────────────────────────

  // Keep avatarRef in sync so interval closures always see the latest position
  const setAvatarAndRef = (pos) => {
    avatarRef.current = pos;
    setAvatar(pos);
  };

  const gameBoard = (w, h) => {
    let board = [];
    for (let idxH = 1; idxH <= h; idxH++) {
      for (let idxW = 1; idxW <= w; idxW++) {
        let comb = `${idxH}|${idxW}`;
        board.push(comb);
      }
    }
    return board;
  };

  const avatarPosition = (w, h) => {
    let widthMid;
    let heightMid;
    if (h === 1) {
      let newHeight = h + 1;
      heightMid = Math.floor(newHeight / 2);
    } else {
      heightMid = Math.floor(h / 2);
    }
    if (w === 1) {
      let newWidth = w + 1;
      widthMid = Math.floor(newWidth / 2);
    } else {
      widthMid = Math.floor(w / 2);
    }
    return heightMid + "|" + widthMid;
  };
 
  const startGame = () => {
    setDisable(true);
    setObjectiveMet(false);
    setResetDone(false);
    setMazeReady(false);                    // NEW: lock out movement/timers until setup completes
    initialSetupPendingRef.current = true;   // NEW: next class-application effect run is the initial draw
    scoreCommittedRef.current = false;       // NEW: this new round's score hasn't been committed yet
    let newBoard = "";
    let avatarPos = "";
    let objectivePos = "";
    let splitsBoard = [];
    if (mazeMemes.topToBottom ===true){
       let goodPath=createGoodPath(gridWidth, gridHeight, 1); 
       avatarPos = goodPath[0]
       setAvatarAndRef(avatarPos);
       setBackToBeginning(avatarPos);
       let lastEntry = goodPath.length - 1;
       objectivePos = goodPath[lastEntry]
       setObjective(goodPath[lastEntry]);
       let savePath = goodPath;
       goodPath=createWiderPath(goodPath); 
       let board = gameBoard(gridWidth, gridHeight);
       let activeBoard = setPathInMaze(board, goodPath, lastEntry, gridWidth, gridHeight, mazeMemes.blockOutImg);
       newBoard = [...activeBoard];
       splitsBoard = JSON.parse(JSON.stringify(newBoard));
       splitsBoard = removeClearPath(splitsBoard, savePath);
    }else{
      let avatarPos = avatarPosition(gridWidth, gridHeight);
      setAvatarAndRef(avatarPos);
      let board = gameBoard(gridWidth, gridHeight);
      let goodPath=createAdditionalSpace(gridWidth, gridHeight, [], pctBlocked, avatarPos); 
      // if cell is in goodPath, it will get a blackoutSquare
      let activeBoard = setBlackOutSpaces(board, goodPath, mazeMemes.blockOutImg, gridWidth, gridHeight);
      newBoard = [...activeBoard];
      // FIX: previously used `_.remove([...newBoard], (n) => n === avatar)`, which
      // (a) mutated a throwaway copy instead of newBoard, so it was a no-op, and
      // (b) compared against the stale `avatar` state instead of the freshly
      // computed `avatarPos`. Net effect: the avatar's starting cell stayed in
      // splitsBoard and could later be sampled into `splits`, causing a pointsObj
      // to appear on the square the avatar started on once the avatar moved away.
      // Using .filter with avatarPos fixes both problems.
      splitsBoard = newBoard.filter((n) => n !== avatarPos);
    }
   
    setSplits(_.sampleSize(splitsBoard, gridHeight));
    // for dogwalker deliveries are bad 
    // they mean contact with a fire hydrant
    setMaxDeliveries(99);
    setDeliveries(0);
    setPlayBoard(newBoard);
    setGameStarted(true);
    setMoves(0);
    setModeLocked(true);
    let addSeconds = 0;
    if (touchMode === true){
      addSeconds = 5;
      if (isTouchDevice === true){
          addSeconds = 3;
      };
    }
    const addOnTime = +(addSeconds * 1000).toFixed(0);
    let effectiveTime = timeAllowed;
    if (touchMode === true){
        effectiveTime += addOnTime;
    }
    // NEW: don't start the timers here. props.startTimer(...) and
    // stateChange(...) used to fire synchronously at this point, which is
    // before the board has actually finished being drawn/styled. Instead,
    // stash what they need and let the "maze finished setting up" effect
    // below kick them off once mazeReady actually flips true.
    pendingTimerStartRef.current = { addSeconds, effectiveTime };
  };
    
  function stateChange(msRemaining) {
      if (gameTimerRef.current) clearTimeout(gameTimerRef.current);
        gameTimerRef.current = setTimeout(function () {
          setDisable(true);
          setGameOver(true);
          commitScoreIfNeeded(); // NEW: commit as soon as the round ends, not on the New Game click
          let displayComment = displayFriendComment(category, props.friendInfo);
          if (displayComment ===true){
                setDisplayPicture(true);
                getComment();
          }
     }, msRemaining);
  }

  function endGame(){
      score.type = "pause";
      // NEW: use the shared commit guard instead of checking resetDone directly.
      // Covers two cases the same way the old resetDone check did:
      //  - Quitting mid-round (round never ended): commits fresh, using
      //    current in-progress deliveries/objectiveMet.
      //  - Quitting after the round already ended (score already committed
      //    at that moment, or already committed via a prior New Game click):
      //    commitScoreIfNeeded returns null, so fall back to current state.
      const scoreObj = commitScoreIfNeeded();
      if (scoreObj){
          score.points = scoreObj.totalScore;
          score.maxScore = scoreObj.maxScore;
          score.nbrAttempted = scoreObj.nbrGames;
          score.gamesRemaining = maxNbrGames - scoreObj.nbrGames;
      }else{
          score.points = totalScore;
          score.maxScore = maxScore;
          score.nbrAttempted = nbrGames;
          score.gamesRemaining = maxNbrGames - nbrGames;
      }  
      score.newLevelEarned = false;
      setScore(score);
      props.onGameOver(score);
  }
  
  function getComment(){
    let commentTable = props.friendInfo.commentTable;
    let commentObj = determineFriendComment(commentTable, commentNbr);
    setComment(commentObj.comment);
    setCommentNbr(commentObj.commentNbr);
  }

  // NEW: accepts optional overrides for objectiveMet/deliveries. This matters
  // when calculateScore is invoked immediately after setObjectiveMet(true)/
  // setDeliveries(...) in the same synchronous block — React hasn't flushed
  // those state updates yet, so reading the `objectiveMet`/`deliveries`
  // closures directly at that moment would see the OLD values (e.g. a
  // topToBottom win could get miscalculated as a loss). Callers that already
  // know the just-decided outcome pass it in explicitly instead of relying
  // on the not-yet-updated state.
  function calculateScore(overrides = {}){
    const effectiveObjectiveMet = overrides.objectiveMet !== undefined ? overrides.objectiveMet : objectiveMet;
    const effectiveDeliveries = overrides.deliveries !== undefined ? overrides.deliveries : deliveries;
    var cumulativeScore = 0;
    var gameCount = nbrGames + 1;
    var maximumPoints = maxScore + gridHeight;
    var perfectGameCount = nbrPerfectGames;
    if (mazeMemes.topToBottom ===true){
       // for games with topToBottom of true (ex: dogWalker), the objective is to avoid the pointsObj
       // in the topToBottom games, deliveries is equal to the number of obstacles
       if (effectiveObjectiveMet === true){
            cumulativeScore = (gridHeight - effectiveDeliveries) + totalScore;
            if (effectiveDeliveries <= 1 ){
                perfectGameCount += 1;
            }
        }else{
            cumulativeScore = totalScore;
        }
    }else{
       if (effectiveDeliveries >= maxDeliveries){
            perfectGameCount = nbrPerfectGames + 1;
       }
       cumulativeScore = totalScore + effectiveDeliveries;
    }
    const scoreObj = {totalScore: cumulativeScore, perfectGameCount: perfectGameCount, maxScore: maximumPoints,
        nbrGames: gameCount};
    return scoreObj;
  }

  // NEW: computes and commits (via setState) the score for the round exactly
  // once. Returns the computed scoreObj if it actually committed, or null if
  // this round's score was already committed (e.g. commitScoreIfNeeded was
  // already called when the round ended, and the player then clicked New
  // Game or Quit afterward — callers should fall back to current state in
  // that case).
  function commitScoreIfNeeded(overrides){
    if (scoreCommittedRef.current) return null;
    scoreCommittedRef.current = true;
    const scoreObj = calculateScore(overrides);
    setmaxScore(scoreObj.maxScore);
    setNbrPerfectGames(scoreObj.perfectGameCount);
    setTotalScore(scoreObj.totalScore);
    if (scoreObj.nbrGames === maxNbrGames){
       setButton1("Finish");
    }else{
       setButton1("New Game");
    }
    setNbrGames(scoreObj.nbrGames);
    return scoreObj;
  }

  function restartGame(){
    setDisplayPicture(false);
    setResetDone(true);
    // NEW: the score for the round that just ended was already committed the
    // moment it ended (see commitScoreIfNeeded calls at each game-over site),
    // so totalScore/nbrGames/maxScore/nbrPerfectGames are already current —
    // that's what makes them visible as soon as "New Game" appears, without
    // waiting for Start. This call is just a safety net in case some future
    // end-of-round path forgets to commit.
    commitScoreIfNeeded();

    if (nbrGames >= maxNbrGames){
        score.type = "finish";
        score.points = totalScore;
        score.gamesRemaining = maxNbrGames - nbrGames;
        score.maxScore = maxScore;
        if (nbrPerfectGames >= 4){
            score.newLevelEarned = true;
        }else{
            score.newLevelEarned = false;
        }
        score.nbrAttempted = nbrGames;
        setScore(score);
        setModeLocked(false);
        props.onGameOver(score);
    }else{
        setDisable(false);
        setGameOver(false);
        setMaxDeliveries(99);
        let board = gameBoard(gridWidth, gridHeight);
        let newboard = clearMazeBoard(board, gridHeight, gridWidth, mazeMemes.blockOutImg, mazeMemes.pointsObj, 
            mazeMemes.avatar, mazeMemes.finishObj);
        setPlayBoard(newboard);
        setDeliveries(0);
        props.stopTimer();
  }
}
  
  const boardRun = (e) => {
    if (!mazeReady) return; // NEW: hard gate — covers keyboard input, D-pad, and any programmatic calls
    let newAvatarPos = 0
    if (maxDeliveries === 99){
          setMaxDeliveries(splits.length);
    }
    if (objectiveMet || gameOver){
          setGameStarted(false);
    }else{
      if (gameStarted){  
          newAvatarPos = moveAvatar(e, avatarRef.current);
          if (mazeMemes.topToBottom ===true){
            if (newAvatarPos ===objective){
                setObjectiveMet(true);
                setGameOver(true);
                props.stopTimer();
                // NEW: pass objectiveMet/deliveries explicitly — setObjectiveMet(true)
                // above hasn't flushed yet, so calculateScore's own `objectiveMet`
                // closure would still read false here without this override.
                commitScoreIfNeeded({ objectiveMet: true, deliveries: deliveries });
                if (category !=="SideHustle" && 
                  props.friendInfo.commentTable){
                  getComment();
                }
            }
          }
      }
    }
  }

  // Synthetic event for on-screen D-pad — moveAvatar only reads e.keyCode
  //const handleDpadPress = (keyCode) => {
  //  boardRun({ keyCode });
  //};
  
  const moveAvatar = (e, currentAvatar) => {
    e = e || window.event;
    let separatorIdx = currentAvatar.indexOf("|");
    let rowNbr = parseInt(currentAvatar.substring(0,separatorIdx));
    let columnNbr = parseInt(currentAvatar.substring(separatorIdx + 1, currentAvatar.length));
    let newPosition = 0;
        
    if (e.keyCode === 38) {
      // up arrow
      let upMove = document.getElementById(`${currentAvatar}`);
      if (upMove  &&
          upMove !== null &&
          playBoard.includes(currentAvatar) &&
          rowNbr >= 2 )
      {
        newPosition = (rowNbr - 1).toString() + "|" + columnNbr.toString();
        if (playBoard.includes(newPosition)){
          upMove.classList.add("plain");
          upMove.classList.remove(mazeMemes.avatar);
          if (splits.length > 1) {
            setMoves(moves + 1);
          }
          setAvatarAndRef(newPosition);
        }
      }
    } else if (e.keyCode === 40) {
      // down arrow
      let downMove = document.getElementById(`${currentAvatar}`);
      if (downMove  &&
          downMove !== null &&
          playBoard.includes(currentAvatar) &&
          rowNbr < gridHeight)     
      {
        newPosition = (rowNbr + 1).toString() + "|" + columnNbr.toString();
        if (playBoard.includes(newPosition)){
          downMove.classList.add("plain");
          downMove.classList.remove(mazeMemes.avatar);
          if (splits.length > 1) {
            setMoves(moves + 1);
          }
          setAvatarAndRef(newPosition);
        }
      }  
    } else if (e.keyCode === 37) {
      // left arrow
      let leftMove = document.getElementById(`${currentAvatar}`);
      if (leftMove  &&
          leftMove !== null &&
          playBoard.includes(currentAvatar) &&
          columnNbr >= 2 )
      {
        newPosition = rowNbr.toString() + "|" + (columnNbr - 1).toString();
        if (playBoard.includes(newPosition)){
          leftMove.classList.add("plain");
          leftMove.classList.remove(mazeMemes.avatar);
          if (splits.length > 1) {
            setMoves(moves + 1);
          }
          setAvatarAndRef(newPosition);
        }
      }
    } else if (e.keyCode === 39) {
      // right arrow
      let rightMove = document.getElementById(`${currentAvatar}`);
      if (rightMove  &&
          rightMove !== null &&
          playBoard.includes(currentAvatar) &&
          columnNbr < gridWidth )
      {
        newPosition = rowNbr.toString() + "|" + (columnNbr + 1).toString();
        if (playBoard.includes(newPosition)){
            rightMove.classList.add("plain");
            rightMove.classList.remove(mazeMemes.avatar);
            if (splits.length > 1) {
                setMoves(moves + 1);
            }
            setAvatarAndRef(newPosition);
            }
        }
    }
    return newPosition;
  };

  // Disable keyboard arrows when in touch mode
  document.onkeydown = touchMode ? null : boardRun;
   
  useEffect(() => {
    let getAvatar = document.getElementById(`${avatar}`);
    if (mazeMemes.bumpRestart ===true){
      if (getAvatar  && getAvatar !== null) {
        // if avatar runs into pointObj, then move avatar back to the beginning
        if (getAvatar.classList.contains(mazeMemes.pointsObj)) {
            setAvatarAndRef(backToBeginning);
            let beginning = document.getElementById(`${backToBeginning}`);
            beginning.classList.add(mazeMemes.avatar);
            setDeliveries(deliveries + 1);
        }else{
          getAvatar.classList.remove("plain");
          getAvatar.classList.add(mazeMemes.avatar);
        }
      }
    }else{
        if (getAvatar  && getAvatar !== null) {
        if (getAvatar.classList.contains(mazeMemes.pointsObj)) {
            getAvatar.classList.remove(mazeMemes.pointsObj);
            setDeliveries(deliveries + 1);
            // filter the current splits table and select anything that is not the 'avatar'
            setSplits(prev => prev.filter((n) => n !== avatar));
        }
        getAvatar.classList.remove("plain");
        getAvatar.classList.add(mazeMemes.avatar);
      }
    }

    if (mazeMemes.topToBottom ===true){
        let getObjective = document.getElementById(`${objective}`);
        if (getObjective  && getObjective !== null) {
            if (getObjective.classList.contains(mazeMemes.pointsObj)) {
              getObjective.classList.remove(mazeMemes.pointsObj);
              _.remove(splits, (n) => n === objective);
            }
            if (avatar ===objective){
                getObjective.classList.remove(mazeMemes.finishObj);
                getObjective.classList.add(mazeMemes.avatar);
            }else{
              getObjective.classList.remove("plain");
              getObjective.classList.add(mazeMemes.finishObj);
            }
        }
    }
     
    if (splitRefreshTimeoutRef.current) {
      clearTimeout(splitRefreshTimeoutRef.current);
    }
    // NEW: if this run is the initial "board just got created" pass (flagged
    // in startGame), apply the pointsObj classes on the very next tick
    // instead of waiting the normal 500ms debounce — there's no reason to
    // delay drawing a board that hasn't been shown yet. Once that first
    // application finishes, flip mazeReady to true and — since the maze is
    // now genuinely ready — kick off props.startTimer(...) and the internal
    // game-over countdown (stateChange), which previously started too early
    // back in startGame().
    const isInitialSetup = initialSetupPendingRef.current;
    splitRefreshTimeoutRef.current = setTimeout(() => {
      _.forEach(splits, (value) => {
        if (value !== avatar) {
          let split = document.getElementById(`${value}`);
          if (split  && split !== null){
            if  (split.classList.contains(mazeMemes.avatar) ||
                split.classList.contains(mazeMemes.blockOutImg) ||
                split.classList.contains(mazeMemes.finishObj)){
                  // skip cell if has specified object
            }else{ 
                split.classList.remove("plain");
                split.classList.add(mazeMemes.pointsObj);
            }
          }
        }
      });
      if (isInitialSetup) {
        initialSetupPendingRef.current = false;
        setMazeReady(true);
        const { addSeconds, effectiveTime } = pendingTimerStartRef.current;
        props.startTimer(touchMode, addSeconds);
        stateChange(effectiveTime);
      }
    }, isInitialSetup ? 0 : 500);
  }, [avatar, splits]);

  
    useEffect(() => {
      if (mazeMemes.topToBottom !== true &&
          gameStarted &&
          !objectiveMet &&
          !gameOver &&
          splits.length < 1 &&
          maxDeliveries !== 99) { // guard so this doesn't fire before splits is ever populated
        setObjectiveMet(true);
        setGameOver(true);
        props.stopTimer();
        commitScoreIfNeeded(); // NEW: commit the instant this round is won, not on the New Game click
      }
    }, [splits]);
  
  return (
    <div    
       aria-labelledby="simple-modal-title"
       aria-describedby="simple-modal-description"
  >
      <div className="row">
          <div className="col-6 mt-2">
              {gameOver ?
                  <span>
                    <Button  
                        type="button"
                        variant="contained"
                        color="primary" 
                        onClick={restartGame} >
                          {button1}
                    </Button>
                   
                  </span>
                :
                    <Button   
                        type="button"
                        variant="contained"
                        color="primary" 
                        disabled={disable} 
                        onClick={startGame} >
                          Start
                    </Button>
              }
              {button1 !== "Finish" ?
                  <Button  className="ml-2"
                      type="button"
                      variant="contained"
                      color="primary" 
                      onClick={endGame} >
                        Quit
                  </Button>
              :
                  null
              }
                
            </div>
            <div className="col-6 py-0">
                   <div>Cumulative Score: {totalScore}&nbsp;out&nbsp;of&nbsp;{maxScore}</div>
                   <div>Nbr Games: {nbrGames}&nbsp;of&nbsp; {maxNbrGames}</div>
            </div>
        </div>
       
        <div className = "row">
            <div className="col-md-6 mb-2">
                {gameOver ? 
                    <div className=" font-weight-bold">
                        <div>Game Over!!!!</div>
                        <div>Click "Reset" to play again.</div>
                    </div>
                : 
                    <div className="font-weight-bold">
                          <div>When you are ready to go</div>
                          <div className="font-weight-bold">click the "Start" button. </div>
                    </div>
                }
            </div>

            {/* ── Controls: arrow key image + toggle button + optional D-pad ── */}
            <div className="col-md-4">
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>

                {touchMode ? (
                  // TOUCH MODE: D-pad on left, switch button on right
                  <>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "2px" }}>
                      <button
                        onPointerDown={() => startHold(38)}
                        onPointerUp={stopHold}
                        onPointerLeave={stopHold}
                        style={dpadBtnStyle}
                        aria-label="Move up"
                      >&#9650;</button>
                      <div style={{ display: "flex", gap: "2px" }}>
                        <button
                          onPointerDown={() => startHold(37)}
                          onPointerUp={stopHold}
                          onPointerLeave={stopHold}
                          style={dpadBtnStyle}
                          aria-label="Move left"
                        >&#9664;</button>
                        <div style={{ width: dpadSize, height: dpadSize }} />
                        <button
                          onPointerDown={() => startHold(39)}
                          onPointerUp={stopHold}
                          onPointerLeave={stopHold}
                          style={dpadBtnStyle}
                          aria-label="Move right"
                        >&#9654;</button>
                      </div>
                      <button
                        onPointerDown={() => startHold(40)}
                        onPointerUp={stopHold}
                        onPointerLeave={stopHold}
                        style={dpadBtnStyle}
                        aria-label="Move down"
                      >&#9660;</button>
                    </div>
                    <Button
                      type="button"
                      variant="contained"
                      color="primary"
                      size="small"
                      disabled={modeLocked}
                      className="switch-btn"
                      onClick={() => handleTouchToggle(false)}
                      style={{ opacity: modeLocked ? 0.4 : 1 }}
                      title={modeLocked ? "Mode locked for this session" : ""}
                    >
                      Switch to Arrow Keys
                    </Button>
                  </>
                ) : (
                  // ARROW KEY MODE: image on left with label below it, button to the right
                  <>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                      <img src="./assets/Activities/SideHustle/arrowKeys.jpg"
                          className="arrowKeys-maze-position"
                          alt="arrowKeys"
                          style={{ position: "static", top: "unset", left: "unset",
                                   transform: "none", zIndex: "unset",
                                   height: "3.5em", width: "3.5em", display: "block" }}/>
                      <b style={{ whiteSpace: "nowrap" }}>Use Arrow Keys</b>
                    </div>
                    <Button
                      type="button"
                      variant="contained"
                      color="primary"
                      size="small"
                      disabled={modeLocked}
                      onClick={() => handleTouchToggle(true)}
                      style={{ whiteSpace: "normal", width: "80px", lineHeight: "1.3",
                               opacity: modeLocked ? 0.4 : 1 }}
                      title={modeLocked ? "Mode locked for this session" : ""}
                    >
                      Switch to Touch
                    </Button>
                  </>
                )}

              </div>
            </div>

              {category !=="SideHustle" && displayPicture  ?
                  <span>
                      <div>
                          <img src={props.friendInfo.friendImgURL}  className="friend-maze-position-img" 
                              alt="friendPicture"/>
                      </div>  
                      <div className="speech-maze-position speech-puzzle-activity right" >
                          {comment}
                      </div>
                  </span>
                :
                    null
                }
      
        <div className={"root2"}>
          <div className={"mt-2"}>
              {Array.from({ length: gridHeight }, (_, h) => h + 1).map((hValue) => (
                <Grid key={hValue} container spacing={1} direction="row" className="mt-1">
                  {Array.from({ length: gridWidth }, (_, i) => i + 1).map((value) => (
                    <Grid key={value} item>
                      <Paper className={mazeMemes.plainCell}>
                        <span id={`${hValue}|${value}`} className={`plain`}>
                          {/* {`${hValue}${value}`} */}
                        </span>
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
              ))}
          </div>
        </div>
      </div>
            
    </div>
  );
}

// ── D-pad button styling ─────────────────────────────────────────────────────
const dpadSize = "32px";   // smaller than before (was 44px) but still tappable

const dpadBtnStyle = {
  width: dpadSize,
  height: dpadSize,
  fontSize: "14px",
  lineHeight: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#1976d2",  // matches MUI primary blue used elsewhere
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  userSelect: "none",
  WebkitUserSelect: "none",
  touchAction: "manipulation", // prevents 300ms tap delay on iOS
};

export default MazeGameModal;
